import server from "../utils/request.js";
import qs from "qs";
import { dict } from "../utils/base";

import axios from "axios"; //调用本地JSON文件用

// const adminURL = dict.ADMIN_URL;
const adminURL = 'https://djpm.delightmom.com/dlm';
// const adminURL = 'https://124.220.72.144:40100';

//三级目录
// export function catalogue (data) {
//   return server.post(adminURL + '/api/login', {data});
// }

//上传图片和视频
export function uploadFile (data) {
  return server.post(adminURL + '/api/school/uploadFile', data);
}

/*
  班级管理
*/
//获取班级列表
export function getClassroomList (data) {
  return server.get(adminURL + '/api/teachermgt/getClassroomList', {
    params: data
  });
}
//添加班级
export function addClassRoom (data) {
  return server.post(adminURL + '/api/teachermgt/addClassRoom', qs.stringify(data));
}
//获取所属课程
export function getClassByEmployId (data) {
  return server.get(adminURL + '/api/teachermgt/getClassByEmployId', {
    params: data
  });
}
//获取主讲老师
export function getEmployListBySchoolId (data) {
  return server.get(adminURL + '/api/teachermgt/getEmployListBySchoolId', {
    params: data
  });
}
//获取班级详情
export function getClassroomDetail (data) {
  return server.get(adminURL + '/api/teachermgt/getClassroomDetail', {
    params: data
  });
}
//创建新学员
export function addStudentToV2 (data) {
  return server.post(adminURL + '/api/teachermgt/addStudentTo/v2', qs.stringify(data));
}
//创建学员
export function addRegisterPhoneNumberV2 (data) {
  return server.post(adminURL + '/api/teachermgt/addRegisterPhoneNumber', qs.stringify(data));
}
//获取学校学生
export function getSchoolStudentV2 (data) {
  return server.post(adminURL + '/api/teachermgt/getSchoolStudent/v2', qs.stringify(data));
}
//创建新学员账号
export function addMoreStudentLessonInfo (data) {
  return server.post(adminURL + '/api/teachermgt/addMoreStudentLessonInfo', qs.stringify(data));
}
//批量为班级添加学员手机号
export function addMoreRegisterPhoneNumber (data) {
  return server.post(adminURL + '/api/teachermgt/addMoreRegisterPhoneNumber', qs.stringify(data));
}
//批量为班级添加学员姓名
export function addMoreRegisterName (data) {
  return server.post(adminURL + '/api/teachermgt/addMoreRegisterName', qs.stringify(data));
}
//根据姓名或者手机号查询学生
export function getStudentByNameOrPhone (data) {
  return server.get(adminURL + '/api/teachermgt/getStudentByNameOrPhone', {
    params: data
  });
}
//批量删除学生
export function deleteMoreStudent (data) {
  return server.post(adminURL + '/api/teachermgt/deleteMoreStudent', data);
}
//获取排课列表
export function getPeriodByCourseId (data) {
  return server.get(adminURL + '/api/teachermgt/getPeriodByCourseId', {
    params: data
  });
}
//更新排课
export function updatePeriodTimeList (data) {
  return server.post(adminURL + '/api/teachermgt/updatePeriodTimeList', data);
}
//删除班级
export function deleteClassById (data) {
  return server.post(adminURL + '/api/teachermgt/deleteClassById', qs.stringify(data));
}
export function getExcelData (data) {
  return server.get(adminURL + '/api/teachermgt/getExcelData', {
    params: data
  });
}

/*
  教学管理
*/
//获取老师
export function getEmployList (data) {
  return server.get(adminURL + '/api/teachermgt/getEmployList', {
    params: data
  });
}
export function getEmployCount (data) {
  return server.get(adminURL + '/api/teachermgt/getEmployCount', {
    params: data
  });
}
//获取教学管理列表
export function getfirstList (data) {
  return server.get(adminURL + '/api/teachermgt/first', {
    params: data
  });
}
//课程详情
export function getCourseDetail (data) {
  return server.get(adminURL + '/api/teachermgt/getCourseDetail', {
    params: data
  });
}
//根据课时id查询 课程视频, 教程，教义
export function getPeriodVideoById (data) {
  return server.get(adminURL + '/api/teachermgt/getPeriodVideoById', {
    params: data
  });
}
//更多课程
export function getCourseList (data) {
  return server.get(adminURL + '/api/teachermgt/getCourseList', {
    params: data
  });
}
//根据类型查询课程
export function getCourseListByTypeOrCate (data) {
  return server.get(adminURL + '/api/teachermgt/getCourseListByTypeOrCate', {
    params: data
  });
}
export function activeStudent (data) {
  return server.post(adminURL + '/api/teachermgt/activeStudent', qs.stringify(data));
}
//查询全部班级
export function getClassList (data) {
  return server.get(adminURL + '/api/teachermgt/getClassList', {
    params: data
  });
}
//更新密码
export function updatePassword (data) {
  return server.get(adminURL + '/api/teachermgt/updatePassword', {
    params: data
  });
}
//获取随堂测评
export function getLessonListByStudentId (data) {
  return server.get(adminURL + '/api/studentLessons/getLessonListByStudentId', {
    params: data
  });
}
//提交随堂测评
export function addStudentLessonsRecoder (data) {
  return server.post(adminURL + '/api/studentLessons/addStudentLessonsRecoder/v2', data);
}
//根据课程获取班级
export function getClassByCourseId (data) {
  return server.get(adminURL + '/api/studentLessons/getClassByCourseId', {
    params: data
  });
}
//根据班级查询学生
export function getClassStudentList (data) {
  return server.get(adminURL + '/api/studentLessons/getStudentList', {
    params: data
  });
}
//根据学生查询习题
export function getTechLessonListByStudentId (data) {
  return server.get(adminURL + '/api/studentLessons/getTechLessonListByStudentId', {
    params: data
  });
}
//获取提交个数
export function getStuCorrectCount (data) {
  return server.get(adminURL + '/api/studentLessons/getStuCorrectCount', {
    params: data
  });
}

/*
  学员管理
*/
//获取学员列表
export function getStudentList (data) {
  return server.get(adminURL + '/api/teachermgt/getStudentList', {
    params: data
  });
}
//查看详情
export function getTechStudentDetail (data) {
  return server.get(adminURL + '/api/teachermgt/getTechStudentDetail', {
    params: data
  });
}
//激活学员-账号
export function activeStudentTV2 (data) {
  return server.post(adminURL + '/api/teachermgt/activeStudentT/v2', qs.stringify(data));
}


/*
  作品管理
*/
//查询作品列表
export function getStuProductList (data) {
  return server.get(adminURL + '/api/teachermgt/getStuProductList', {
    params: data
  });
}
//获取作品详情
export function getStuProDetail (data) {
  return server.get(adminURL + '/api/teachermgt/getStuProDetail', {
    params: data
  });
}
//添加评语
export function updateStuProduct (data) {
  return server.post(adminURL + '/api/teachermgt/updateStuProduct', data);
}

/*
  学情管理
*/
//根据老师获取班级
export function getClassById (data) {
  return server.get(adminURL + '/api/teachermgt/getClassById', {
    params: data
  });
}
//根据学生获取班级
export function getClassByStuId (data) {
  return server.get(adminURL + '/api/teachermgt/getClassByStuId', {
    params: data
  });
}
export function getStudentDetail1 (data) {
  return server.get(adminURL + '/api/teachermgt/getStudentDetail1', {
    params: data
  });
}
//获取教师的学情报告-课时分数
export function getStudenRepoortScore (data) {
  return server.get(adminURL + '/api/teachermgt/getStudenRepoortScore', {
    params: data
  });
}
//获取教师的学情报告-能力纬度
export function getStudenRepoortStar (data) {
  return server.get(adminURL + '/api/teachermgt/getStudenRepoortStar', {
    params: data
  });
}
//获取教师的学情报告-学员情况
export function getStudenRepoortStu (data) {
  return server.get(adminURL + '/api/teachermgt/getStudenRepoortStu', {
    params: data
  });
}
//根据教师课程学生名搜索
export function seachStudent (data) {
  return server.get(adminURL + '/api/teachermgt/seachStudent', {
    params: data
  });
}
//学生学情管理
export function getStuReport (data) {
  return server.get(adminURL + '/api/teachermgt/getStuReport', {
    params: data
  });
}
//学生学情随堂测评
export function getStudentPeriodScroe (data) {
  return server.get(adminURL + '/api/teachermgt/getStudentPeriodScroe', {
    params: data
  });
}
//查询学生课程列表
export function getStuCourseList (data) {
  return server.get(adminURL + '/api/stu/course/getStuCourseList', {
    params: data
  });
}


/*
  登录
*/
//密码登录
export function loginWithPassword (data) {
  return server.post(adminURL + '/api/teachermgt/loginWithPassword/v2', qs.stringify(data));
}
//验证码登录
export function getCode (data) {
  return server.get(adminURL + '/api/teachermgt/getCode', {
    params: data
  });
}
export function loginWithCode (data) {
  return server.post(adminURL + '/api/teachermgt/login/v2', qs.stringify(data));
}
//修改密码
export function resetPassword (data) {
  return server.post(adminURL + '/api/teachermgt/resetPassword', qs.stringify(data));
}

//创作工具
export function getConfigDownList (data) {
  return server.get(adminURL + '/api/coursedown/getConfigDownList', {
    params: data
  });
}

//消息
//一键已读
export function allRead (data) {
  return server.get(adminURL + '/api/coursemessage/allRead', {
    params: data
  });
}
//获取消息
export function getPersonMessageList (data) {
  return server.get(adminURL + '/api/coursemessage/getPersonMessageList', {
    params: data
  });
}
//修改已读状态
export function updateMsgState (data) {
  return server.post(adminURL + '/api/coursemessage/updateMsgState', qs.stringify(data));
}

//获取学情管理的时间
export function getSemesterTime (data) {
  return server.get(adminURL + '/api/teachermgt/getSemesterTime', {
    params: data
  });
}

//订单管理
//获取订单管理列表
export function getOrderList (data) {
  return server.get(adminURL + '/api/operation/order/getOrderList', {
    params: data
  });
}
//获取订单管理详情
export function getOrderDetail (data) {
  return server.get(adminURL + '/api/operation/order/getOrderDetail', {
    params: data
  });
}
//获取学校列表
export function getSchoolListByParmasV2 (data) {
  return server.get(adminURL + '/api/school/getSchoolListByParmas/v2', {
    params: data
  });
}
//根据学校id获取员工
export function getSchoolEmployessV2 (data) {
  return server.post(adminURL + '/api/school/getSchoolEmployess/v2', qs.stringify(data));
}
//获取订单管理列表-账号
export function getOrderListV2 (data) {
  return server.get(adminURL + '/api/operation/order/getOrderList/v2', {
    params: data
  });
}
//获取订单管理详情-账号
export function getOrderDetailV2 (data) {
  return server.get(adminURL + '/api/operation/order/getOrderDetail/v2', {
    params: data
  });
}


// WEBPACK FOOTER //
// ./src/api/datas.js